import DashboardBody from "./DashboardBody";

export default function DashboardPage() {
  return <DashboardBody />;
}
